export default {
    label: 'Kontaktní formulář',
    phonePlaceholder: 'Telefon',
    description: 'Zanechte nám na Vás kontakt a my se Vám co nejdříve ozveme.',
    submitButton: 'Odeslat',

    successMessageSent: 'Formulář byl úspěšně odeslán, budeme Vás kontaktovat.'
}
